// authenticatedAxios.js
// Shared axios instance for authenticated API calls
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost';

// Create axios instance for authenticated API calls
const authenticatedAxios = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add JWT token
authenticatedAxios.interceptors.request.use(
  (config) => {
    // CRITICAL FIX: For MSIL users, use msil_id_token (contains email claims)
    // For MASS users, use sessionStorage token
    // Priority: msil_id_token > token (for MSIL users with Cognito tokens)
    const token = localStorage.getItem('msil_id_token') || sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
const skipAuthRedirect = process.env.REACT_APP_SKIP_AUTH_REDIRECT === 'true';
authenticatedAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
       // Testing: skip redirect so /services, /home etc. can be used without login
       if (skipAuthRedirect) {
        console.warn('Unauthorized (401) - staying on page (REACT_APP_SKIP_AUTH_REDIRECT=true)');
        return Promise.reject(error);
      }
      // Token expired or invalid - redirect to login
      console.error('Unauthorized: Token expired or invalid - redirecting to login');
      
      // Clear all authentication data
      localStorage.removeItem('msil_id_token');
      localStorage.removeItem('msil_access_token');
      localStorage.removeItem('msil_code_used');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('role');
      sessionStorage.removeItem('email');
      sessionStorage.removeItem('uid');
      sessionStorage.removeItem('otpVerified');
      sessionStorage.removeItem('msil_code_used');
      
      // Redirect to login page
      window.location.href = '/login';
    } else if (error.response?.status === 403) {
      // Not authorized
      console.error('Forbidden: User does not have required permissions');
    }
    return Promise.reject(error);
  }
);

export default authenticatedAxios;


